<mat-dialog-content>
  <p class="mat-body-1">Enter a name for the archive</p>
  <mat-form-field>
    <input matInput [(ngModel)]="name" type="text" placeholder="Archive name">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="name" [disabled]="!name.length">Confirm</button>
</mat-dialog-actions>